import { MessageState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: MessageState = {
  message: null,
  values: undefined,
  multimediaMessage: null,
  multimediaValues: undefined,
}

const messageSlice = createSlice({
  name: 'messageFeature',
  initialState,
  reducers: {
    showMessage(state, action: PayloadAction<{ message: string; values?: object }>) {
      state.message = action.payload.message
      state.values = action.payload.values
    },
    hideMessage(state) {
      state.message = initialState.message
      state.values = initialState.values
    },
    showMultimediaMessage(state, action: PayloadAction<{ message: string; values?: object }>) {
      state.multimediaMessage = action.payload.message
      state.multimediaValues = action.payload.values
    },
    hideMultimediaMessage(state) {
      state.multimediaMessage = initialState.multimediaMessage
      state.multimediaValues = initialState.values
    },
  },
})

export const { showMessage, hideMessage, showMultimediaMessage, hideMultimediaMessage } = messageSlice.actions
export default messageSlice.reducer
